// Etikett til sykkelen i sykkelhotellet: nummer, kunde, sykkel og plass.
// Bygges som HTML-tekst, så alle verdier escapes (regel S4).
import { escapeHtml } from "./format";
import { kundeNavn } from "../constants/dekkhotell";
import { sykkelTekst } from "../constants/sykkelhotell";

export function skrivUtEtikett(post) {
  const w = window.open("", "_blank", "width=420,height=600");
  if (!w) return alert("Tillat popup-vinduer for å skrive ut etiketten.");
  const navn = kundeNavn(post.kunde);
  const tlf = post.kunde?.normalizedPhone ? `…${post.kunde.normalizedPhone.slice(-3)}` : "";
  const batteri = post.elsykkel ? (post.batteriMed ? "Elsykkel, batteri med" : "Elsykkel, batteri ikke med") : "";
  w.document.write(`<!doctype html><html lang="no"><head><meta charset="utf-8">
    <title>Etikett ${escapeHtml(post.nr)}</title>
    <style>
      body { font-family: system-ui, sans-serif; margin: 0; }
      .etikett { width: 90mm; padding: 4mm; border: 1px dashed #999; margin: 4mm; page-break-inside: avoid; }
      .nr { font-size: 28pt; font-weight: 800; letter-spacing: 1px; }
      .navn { font-size: 13pt; font-weight: 600; margin-top: 2mm; }
      .tlf { font-weight: 400; color: #444; }
      .linje { margin-top: 1mm; font-size: 11pt; }
      @media print { .etikett { border: none; } }
    </style></head><body>
    <div class="etikett">
      <div class="nr">${escapeHtml(post.nr)}</div>
      <div class="navn">${escapeHtml(navn)} <span class="tlf">${escapeHtml(tlf)}</span></div>
      <div class="linje">${escapeHtml(sykkelTekst(post))}</div>
      ${batteri ? `<div class="linje">${escapeHtml(batteri)}</div>` : ""}
      ${post.medfolger ? `<div class="linje">Med: ${escapeHtml(post.medfolger)}</div>` : ""}
      <div class="linje">Plass: ${escapeHtml(post.plass || "—")} · Sesong ${escapeHtml(post.sesong || "")}</div>
    </div>
    <script>window.onload = () => { window.print(); }</script></body></html>`);
  w.document.close();
}
